import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "QUAY_MANUAL",
    applicationRights: Rights,
    title: "Kaibok",
    text: "Kaibok",
    icon: "book-open-text",
    url: "/quaymanuals",
    mobileThreshold: 1024,
    sequenceNo: 8000,
    routes: Routes
});
